<template>
  <div class="img-swiper">
    <div class="swiper-upload"  @click="upload" @change="handleFile" v-if="edit">
      <input type="file" :id="id" style="display:none" accept="image/png, image/jpeg, image/jpg">
      <i class="el-icon-plus add-plus"></i>
    </div>
    <div class="swiper-img-content" v-loading="loading">
       <swiper class="swiper" ref="swiper" :options="swiperOption">
        <swiper-slide v-for="(item,key) in imgList" :key="key">
          <div class="img-content">
            <el-image
                class="img-content-el-img"
                :src="item"
                :preview-src-list="imgList">
              </el-image>
            <i class="el-icon-error img-content-colse" v-if="edit" @click="deleteImg(key)"></i>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev swiper-button-grey" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-grey" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
// swiper 滑动组件----pc移动混用
// 可以设置上传显示不显示edid字段 ui完成
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import '../swiper3.1.3.css'
import { postAction } from '@/api/manage'
export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    edit: {
      default: true,
      type: Boolean
    },
    obj: {
      default: () => { return {} },
      type: Object
    },
    imgListMessage: {
      default: () => { return [] },
      type: Array
    },
    imgProperty: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      loading: false,
      imgList: [],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 0,
        direction: 'horizontal',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    isMobile() {
      const isMob = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return isMob
    }
  },
  methods: {
    handleFile(e) {
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      this.loading = true
      postAction('/image/v0.2/api/images?folder=wwp_review', formData).then((res) => {
        if (res.code === 200) {
          // 上传成功后
          this.imgList.push(res.result)
          this.loading = false
          this.obj[this.imgProperty] = this.imgList
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },
    upload() {
      if (this.loading) { return false }
      if (this.imgList.length > 10) {
        this.$message.error('maxLeng is 10')
      }
      document.getElementById(this.id).click()
    },
    deleteImg(key) {
      this.imgList.splice(key, 1)
      this.obj[this.imgProperty] = this.imgList
    }
  }
}
</script>

<style lang="less" scoped>
.m-swiper-img-content{
  width: 70%;
}
.img-swiper-100{
  display: flex;
  max-width: 100% !important;
  .swiper-img-content{
    max-width: 100% !important;
  }
}
.swiper-upload {
  width: 95px;
  height: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #5D5D5D;
  background: #ffffff;
  cursor: pointer;
  margin-right: 10px;
  .add-plus{
    font-size: 22px;
    color: #8F8F8F;
  }
}

/deep/ .swiper-container{
  width: 100%;
}

.img-swiper{
  display: flex;
}
.swiper-img-content{
  width: 800px;
  // padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  // margin-left: 20px;
}
.swiper{
  .swiper-button-grey{
    background-size: 50% 50%
  }
  .img-content{
    width: 95px;
    height: 95px;
    // background: #e1e1e1;
    display: flex;
    justify-content: right;
    position: relative;
    box-sizing: border-box;
    .img-content-colse{
      position: absolute;
      font-size: 18px;
    }
  }
}
/deep/ .el-image__inner.el-image__preview{
  width: 95px;
  height: 95px;
}
/deep/ .swiper-slide.swiper-slide-active{
  width: 100px !important
}
/deep/ .swiper-slide.swiper-slide-next{
  width: 100px !important
}
/deep/ .swiper-slide.swiper-slide{
  width: 100px !important
}
/deep/ .swiper-img-content{
  width: calc(100% - 95px);
}
@media screen and(max-width: 600px) {

}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/img-swiper-review.vue